(() => {
  class ProductQuantitySelector extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      this.decreaseButton = this.querySelector('[data-quantity-decrease]');
      this.increaseButton = this.querySelector('[data-quantity-increase]');
      this.onVariantChange = this.onVariantChange.bind(this);

      this.decreaseButton && this.decreaseButton.addEventListener('click', () => this.changeQuantity(-1));
      this.increaseButton && this.increaseButton.addEventListener('click', () => this.changeQuantity(1));
      this.input && this.input.addEventListener('change', () => this.setQuantity(this.input.value));
      document.addEventListener('product:variant-change', this.onVariantChange);

      this.updateButtonStates();
      this.dispatchQuantityChange();
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      const eventScope = event.detail && event.detail.scope;

      if (!variant) return;
      if ((eventScope || this.scope) && eventScope !== this.scope) return;

      const maxQuantity = variant.available ? Number(variant.max_quantity || 100) : 0;
      const nextQuantity = variant.available ? Math.min(Math.max(this.quantity, 1), maxQuantity) : 0;

      this.maxQuantity = maxQuantity;
      this.disabled = !variant.available;
      this.setQuantity(nextQuantity);
    }

    changeQuantity(delta) {
      this.setQuantity(this.quantity + delta);
    }

    setQuantity(value) {
      if (!this.input) return;

      const min = this.disabled ? 0 : 1;
      const parsedValue = Number.parseInt(value, 10);
      const quantity = Number.isNaN(parsedValue) ? min : parsedValue;
      const nextQuantity = Math.min(Math.max(quantity, min), this.maxQuantity);

      const error = this.querySelector('[data-quantity-error]');
      if (error) {
        error.hidden = quantity <= this.maxQuantity;
        error.textContent = error.hidden ? '' : this.dataset.limitMessage.replace('[quantity]', String(this.maxQuantity));
      }
      this.input.value = String(nextQuantity);
      this.updateButtonStates();
      this.dispatchQuantityChange();
    }

    updateButtonStates() {
      if (!this.input) return;

      const quantity = this.quantity;

      this.classList.toggle('is-zero', quantity === 0);
      this.input.min = this.disabled ? '0' : '1';
      this.input.max = String(this.maxQuantity);
      this.input.disabled = this.disabled;

      if (this.decreaseButton) {
        this.decreaseButton.disabled = this.disabled || quantity <= 1;
      }

      if (this.increaseButton) {
        this.increaseButton.disabled = this.disabled || quantity >= this.maxQuantity;
      }
    }

    dispatchQuantityChange() {
      document.dispatchEvent(
        new CustomEvent('product:quantity-change', {
          detail: { quantity: this.quantity, scope: this.scope }
        })
      );
    }

    get quantity() {
      return this.input ? Number.parseInt(this.input.value, 10) || 0 : 0;
    }

    get maxQuantity() {
      return Number(this.dataset.maxQuantity || 100);
    }

    set maxQuantity(value) {
      this.dataset.maxQuantity = String(value);
    }

    get disabled() {
      return this.hasAttribute('disabled');
    }

    set disabled(value) {
      this.toggleAttribute('disabled', value);
    }

    get scope() {
      return this.dataset.productUiScope || this.closest('.product-layout, .featured-product-showcase, [data-search-product-drawer]') || '';
    }
  }

  if (!customElements.get('product-quantity-selector')) {
    customElements.define('product-quantity-selector', ProductQuantitySelector);
  }
})();
